import { passenger, PassengerCounts } from "../../constants/types";
import {
  calculateCommissionAmount,
  extractBookingDataFromFlight,
  matchCommissionRule,
} from "../../constants/helper";
import { useGlobalState } from "../context/AuthContext";
import { UtilService } from "../shared/UtilService";

type UseCommissionReturn = {
  commission: number;
  finalFare: number;
  ruleId?: number;
};

export const useCommission = (
  flightData: any,
  passengerCounts: passenger
): UseCommissionReturn => {
  const { commissionRules } = useGlobalState();

  if (!flightData?.Bonds?.length || !flightData.Fare) {
    return {
      commission: 0,
      finalFare: flightData?.Fare?.TotalFareWithOutMarkUp ?? 0,
    };
  }

  const bookingData = extractBookingDataFromFlight(flightData);
  const tripType =
    bookingData.tripType === "ONE-WAY" || bookingData.tripType === "ROUND-TRIP"
      ? bookingData.tripType
      : "ONE-WAY"; // fallback

  let totalCommission = 0;
  let ruleId;

  for (const bond of flightData.Bonds) {
    const segment = bond.Legs?.[0];
    if (!segment) continue;

    const rule = matchCommissionRule(bookingData, commissionRules);

    const result = calculateCommissionAmount(
      rule,
      flightData?.Fare?.TotalFareWithOutMarkUp,
      passengerCounts,
      tripType
    );

    totalCommission += result.totalCommission;
    ruleId = result.appliedRuleId;
  }

  const finalFare = totalCommission;

  return {
    commission: totalCommission,
    finalFare,
    ruleId: ruleId,
  };
};
